import React, { useEffect } from "react";
import { Icon } from 'antd';
import LoadMapAndDraw from "../../utils/LoadMaps";


function LeafletModal({ id, lat, lng, marker, circle, changeShowMap }) {
    const zoom = 17;
    const scriptMapAndDraw = LoadMapAndDraw();

    useEffect(() => {
        if (scriptMapAndDraw === "ready") {
            initMap();
        }
        // eslint-disable-next-line
    }, [scriptMapAndDraw])

    const initMap = () => {

        const L = window.L;

        var centro = [lat, lng];

        // MAPA
        var mymap = L.map(id).setView(centro, zoom);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(mymap);

        // MARKER
        if (marker) {
            var markerLeaflet = L.marker(centro);
            markerLeaflet.addTo(mymap);
        }

        // MARKER CIRCLE
        if (circle) {
            var circleLeaflet = L.circle(centro, {
                color: 'red',
                fillColor: '#f03',
                fillOpacity: 0.5,
                radius: 350
            }).addTo(mymap);
            console.log(circleLeaflet)
        }
    }

    return (
        <div className='PopUpMapa'>
            <i className='PopUpCerrar' onClick={() => changeShowMap()}><Icon type="plus" /></i>
            <div id={id} style={{ width: "100%", height: "100%" }}></div>
        </div>

    )
}

export default LeafletModal;